// extracted by mini-css-extract-plugin
export var backButton = "_l-1";
export var content = "_l-d";
export var continueButton = "_l-7";
export var continueHint = "_l-8";
export var continueRow = "_l-6";
export var leftInner = "_l-0";
export var shell = "_l-e";
export var sidebarContent = "_l-5";
export var skipButton = "_l-c";
export var spacer = "_l-2";
export var spin = "_l-a";
export var spinner = "_l-9";
export var spinnerOverlay = "_l-b";
export var subtitle = "_l-4";
export var title = "_l-3";